import Point3D from '../geom/Point3D'
import ArrayUtils from '../utils/ArrayUtils'
import Point from '../geom/Point'
import BoundingBoxDT from './BoundingBoxDT'
import TriangleDT from './TriangleDT'

function GridIndex(delaunay, xCellCount, yCellCount, region) {
    region = (typeof region === 'undefined') ? null : region;
    this._indexDelaunay = null;
    this._xSize = NaN;
    this._ySize = NaN;
    this._indexRegion = null;
    this._grid = null;
    var r = (region) ? region : delaunay.getBoundingBox();
    this._init(delaunay, xCellCount, yCellCount, r);
}

function DelaunayTriangulation(ps) {
    this._firstP = null;
    this._lastP = null;

    this._allCollinear = false;

    // the first and last triangles (used only for first step construction)
    this._firstT = null;
    this._lastT = null;
    this._currT = null;

    // the triangle the convex hull starts from
    this.startTriangleHull = null;

    this._nPoints = 0; // number of points

    this._vertices = null;
    this._triangles = null;

    // The triangles that were deleted in the last deletePoint iteration.
    this._deletedTriangles = null;
    // The triangles that were added in the last deletePoint iteration.
    this._addedTriangles = null;

    this._modCount = 0;
    this._modCount2 = 0;

    // the Bounding Box, {{x0,y0,z0} , {x1,y1,z1}}
    this._bb_min = null;
    this._bb_max = null;

    /**
     * Index for faster point location searches
     */
    this._gridIndex = null;

    // the triangle the fond (search start from
    this._startTriangle = null;


    this._modCount = 0;
    this._modCount2 = 0;
    this._bb_min = null;
    this._bb_max = null;
    this._vertices = [];
    this._triangles = [];
    this._deletedTriangles = null;
    this._addedTriangles = [];
    this._allCollinear = true;
    for (var i = 0; ps != null && i < ps.length && ps[i] != null; i++) {
        this.insertPoint(ps[i]);
    }
}

DelaunayTriangulation.prototype = {

    getLength: function() {
        if (this._vertices == null) {
            return 0;
        }
        return this._vertices.length;
    },

    /**
     * @return the number of triangles in the triangulation. <br />
     * Note: includes infinife faces!!.
     */
    getTrianglesLength: function() {
        this.initTriangles();
        return this._triangles.length;
    },

    /**
     * returns the changes counter for this triangulation
     */
    getModeCounter: function() {
        return this._modCount;
    },

    /**
     * insert the point to this Delaunay Triangulation. Note: if p is null or
     * already exist in this triangulation p is ignored.
     *
     * @param p
     *            new vertex to be inserted the triangulation.
     */
    insertPoint: function(p) {
        if (this._vertices.indexOf(p) >= 0)
            return;
        this._modCount++;
        this.updateBoundingBox(p);
        this._vertices.push(p);
        var t = this.insertPointSimple(p);
        if (t == null) //
            return;
        var tt = t;
        // eslint-disable-next-line no-undef
        this._currT = t; // recall the last point for - fast (last) update iterator.
        do {
            this.flip(tt, this._modCount);
            tt = tt.canext;
        } while (tt != t && !tt.isHalfplane());

        // Update index with changed triangles
        if (this._gridIndex != null)
            this._gridIndex.updateIndex(this.getLastUpdatedTriangles());
    },

    deletePoint: function(pointToDelete) {

        // Finding the triangles to delete.
        var pointsVec = this._findConnectedVertices(pointToDelete, true);
        if (pointsVec == null) {
            return;
        }

        while (pointsVec.length >= 3) {
            // Getting a triangle to add, and saving it.
            var triangle = this.findTriangle(pointsVec, pointToDelete);
            this._addedTriangles.push(triangle);

            // Finding the point on the diagonal (pointToDelete,p)
            var p = this.findDiagonal(triangle, pointToDelete);

            for (var i = pointsVec.length - 1; i >= 0; i--) {
                var tmpP = pointsVec[i];
                if (tmpP.equals(p)) {
                    ArrayUtils.deleteAt(pointsVec, i);
                }
            }
        }
        //updating the trangulation
        this.deleteUpdate(pointToDelete);

        for (var j = 0; j < this._deletedTriangles.length; j++) {
            var t = this._deletedTriangles[j];
            if (t == this._startTriangle) {
                this._startTriangle = this._addedTriangles.elementAt(0);
                break;
            }
        }
        ArrayUtils.deleteElements(this._triangles, this._deletedTriangles);
        ArrayUtils.appendArray(this._addedTriangles, this._triangles);
        ArrayUtils.deleteElement(this._vertices, pointToDelete);

        this._nPoints = this._nPoints + this._addedTriangles.length - this._deletedTriangles.length;
        ArrayUtils.removeAll(this._addedTriangles);
        ArrayUtils.removeAll(this._deletedTriangles);
    },

    /** return a point from the trangulation that is close to pointToDelete
     * @param pointToDelete the point that the user wants to delete
     * @return a point from the trangulation that is close to pointToDelete
     * By Eyal Roth & Doron Ganel (2009).
     */
    findClosePoint: function(pointToDelete) {
        var triangle = this.find(pointToDelete);
        var p1 = triangle.p1();
        var p2 = triangle.p2();
        var d1 = p1.distance(pointToDelete);
        var d2 = p2.distance(pointToDelete);
        if (triangle.isHalfplane()) {
            if (d1 <= d2) {
                return p1;
            } else {
                return p2;
            }
        } else {
            var p3 = triangle.p3();

            var d3 = p3.distance(pointToDelete);
            if (d1 <= d2 && d1 <= d3) {
                return p1;
            } else if (d2 <= d1 && d2 <= d3) {
                return p2;
            } else {
                return p3;
            }
        }
    },

    //updates the trangulation after the triangles to be deleted and
    //the triangles to be added were found
    //by Doron Ganel & Eyal Roth(2009)
    deleteUpdate: function(pointToDelete) {

        for (var i = 0; i < this._addedTriangles.length; i++) {
            var addedTriangle1 = this._addedTriangles[i];
            for (var j = 0; j < this._deletedTriangles.length; j++) {
                var deletedTriangle = this._deletedTriangles[j];
                if (this.shareSegment(addedTriangle1, deletedTriangle)) {
                    this.updateNeighbor(addedTriangle1, deletedTriangle, pointToDelete);
                }
            }
        }

        // eslint-disable-next-line no-redeclare
        for (var i = 0; i < this._addedTriangles.length; i++) {
            var addedTriangle1b = this._addedTriangles[i];
            // eslint-disable-next-line no-redeclare
            for (var j = 0; j < this._addedTriangles.length; j++) {
                var addedTriangle2b = this._addedTriangles[j];
                if ((addedTriangle1b != addedTriangle2b) && (this.shareSegment(addedTriangle1b, addedTriangle2b))) {
                    this._updateNeighbor(addedTriangle1b, addedTriangle2b);
                }
            }
        }


        // Update index with changed triangles
        if (this._gridIndex != null)
            this._gridIndex.updateIndex(this._addedTriangles);

    },

    //checks if the 2 triangles shares a segment
    //by Doron Ganel & Eyal Roth(2009)
    shareSegment: function(t1, t2) {
        var counter = 0;
        var t1P1 = t1.p1();
        var t1P2 = t1.p2();
        var t1P3 = t1.p3();
        var t2P1 = t2.p1();
        var t2P2 = t2.p2();
        var t2P3 = t2.p3();

        if (t1P1.equals(t2P1)) {
            counter++;
        }
        if (t1P1.equals(t2P2)) {
            counter++;
        }
        if (t1P1.equals(t2P3)) {
            counter++;
        }
        if (t1P2.equals(t2P1)) {
            counter++;
        }
        if (t1P2.equals(t2P2)) {
            counter++;
        }
        if (t1P2.equals(t2P3)) {
            counter++;
        }
        if (t1P3.equals(t2P1)) {
            counter++;
        }
        if (t1P3.equals(t2P2)) {
            counter++;
        }
        if (t1P3.equals(t2P3)) {
            counter++;
        }
        if (counter >= 2)
            return true;
        else
            return false;
    },

    updateNeighbor: function(addedTriangle, deletedTriangle, pointToDelete) {
        var delA = deletedTriangle.p1();
        var delB = deletedTriangle.p2();
        var delC = deletedTriangle.p3();
        var addA = addedTriangle.p1();
        var addB = addedTriangle.p2();
        var addC = addedTriangle.p3();

        //updates the neighbor of the deleted triangle to point to the added triangle
        //setting the neighbor of the added triangle
        if (pointToDelete.equals(delA)) {
            deletedTriangle.next_23().switchneighbors(deletedTriangle, addedTriangle);
            //AB-BC || BA-BC
            if ((addA.equals(delB) && addB.equals(delC)) || (addB.equals(delB) && addA.equals(delC))) {
                addedTriangle.abnext = deletedTriangle.next_23();
            }
            //AC-BC || CA-BC
            else if ((addA.equals(delB) && addC.equals(delC)) || (addC.equals(delB) && addA.equals(delC))) {
                addedTriangle.canext = deletedTriangle.next_23();
            }
            //BC-BC || CB-BC
            else {
                addedTriangle.bcnext = deletedTriangle.next_23();
            }
        } else if (pointToDelete.equals(delB)) {
            deletedTriangle.next_31().switchneighbors(deletedTriangle, addedTriangle);
            //AB-AC || BA-AC
            if ((addA.equals(delA) && addB.equals(delC)) || (addB.equals(delA) && addA.equals(delC))) {
                addedTriangle.abnext = deletedTriangle.next_31();
            }
            //AC-AC || CA-AC
            else if ((addA.equals(delA) && addC.equals(delC)) || (addC.equals(delA) && addA.equals(delC))) {
                addedTriangle.canext = deletedTriangle.next_31();
            }
            //BC-AC || CB-AC
            else {
                addedTriangle.bcnext = deletedTriangle.next_31();
            }
        }
        //equals c
        else {
            deletedTriangle.next_12().switchneighbors(deletedTriangle, addedTriangle);
            //AB-AB || BA-AB
            if ((addA.equals(delA) && addB.equals(delB)) || (addB.equals(delA) && addA.equals(delB))) {
                addedTriangle.abnext = deletedTriangle.next_12();
            }
            //AC-AB || CA-AB
            else if ((addA.equals(delA) && addC.equals(delB)) || (addC.equals(delA) && addA.equals(delB))) {
                addedTriangle.canext = deletedTriangle.next_12();
            }
            //BC-AB || CB-AB
            else {
                addedTriangle.bcnext = deletedTriangle.next_12();
            }
        }
    },

    //update the neighbors of the 2 added Triangle s
    //we assume the 2 triangles share a segment
    //by Doron Ganel & Eyal Roth(2009)
    _updateNeighbor: function(addedTriangle1, addedTriangle2) {
        var A1 = addedTriangle1.p1();
        var B1 = addedTriangle1.p2();
        var C1 = addedTriangle1.p3();
        var A2 = addedTriangle2.p1();
        var B2 = addedTriangle2.p2();
        var C2 = addedTriangle2.p3();

        //A1-A2
        if (A1.equals(A2)) {
            //A1B1-A2B2
            if (B1.equals(B2)) {
                addedTriangle1.abnext = addedTriangle2;
                addedTriangle2.abnext = addedTriangle1;
            }
            //A1B1-A2C2
            else if (B1.equals(C2)) {
                addedTriangle1.abnext = addedTriangle2;
                addedTriangle2.canext = addedTriangle1;
            }
            //A1C1-A2B2
            else if (C1.equals(B2)) {
                addedTriangle1.canext = addedTriangle2;
                addedTriangle2.abnext = addedTriangle1;
            }
            //A1C1-A2C2
            else {
                addedTriangle1.canext = addedTriangle2;
                addedTriangle2.canext = addedTriangle1;
            }
        }
        //A1-B2
        else if (A1.equals(B2)) {
            //A1B1-B2A2
            if (B1.equals(A2)) {
                addedTriangle1.abnext = addedTriangle2;
                addedTriangle2.abnext = addedTriangle1;
            }
            //A1B1-B2C2
            else if (B1.equals(C2)) {
                addedTriangle1.abnext = addedTriangle2;
                addedTriangle2.bcnext = addedTriangle1;
            }
            //A1C1-B2A2
            else if (C1.equals(A2)) {
                addedTriangle1.canext = addedTriangle2;
                addedTriangle2.abnext = addedTriangle1;
            }
            //A1C1-B2C2
            else {
                addedTriangle1.canext = addedTriangle2;
                addedTriangle2.bcnext = addedTriangle1;
            }
        }
        //A1-C2
        else if (A1.equals(C2)) {
            //A1B1-C2A2
            if (B1.equals(A2)) {
                addedTriangle1.abnext = addedTriangle2;
                addedTriangle2.canext = addedTriangle1;
            }
            //A1B1-C2B2
            if (B1.equals(B2)) {
                addedTriangle1.abnext = addedTriangle2;
                addedTriangle2.bcnext = addedTriangle1;
            }
            //A1C1-C2A2
            if (C1.equals(A2)) {
                addedTriangle1.canext = addedTriangle2;
                addedTriangle2.canext = addedTriangle1;
            }
            //A1C1-C2B2
            else {
                addedTriangle1.canext = addedTriangle2;
                addedTriangle2.bcnext = addedTriangle1;
            }
        }
        //B1-A2
        else if (B1.equals(A2)) {
            //B1A1-A2B2
            if (A1.equals(B2)) {
                addedTriangle1.abnext = addedTriangle2;
                addedTriangle2.abnext = addedTriangle1;
            }
            //B1A1-A2C2
            else if (A1.equals(C2)) {
                addedTriangle1.abnext = addedTriangle2;
                addedTriangle2.canext = addedTriangle1;
            }
            //B1C1-A2B2
            else if (C1.equals(B2)) {
                addedTriangle1.bcnext = addedTriangle2;
                addedTriangle2.abnext = addedTriangle1;
            }
            //B1C1-A2C2
            else {
                addedTriangle1.bcnext = addedTriangle2;
                addedTriangle2.canext = addedTriangle1;
            }
        }
        //B1-B2
        else if (B1.equals(B2)) {
            //B1A1-B2A2
            if (A1.equals(A2)) {
                addedTriangle1.abnext = addedTriangle2;
                addedTriangle2.abnext = addedTriangle1;
            }
            //B1A1-B2C2
            else if (A1.equals(C2)) {
                addedTriangle1.abnext = addedTriangle2;
                addedTriangle2.bcnext = addedTriangle1;
            }
            //B1C1-B2A2
            else if (C1.equals(A2)) {
                addedTriangle1.bcnext = addedTriangle2;
                addedTriangle2.abnext = addedTriangle1;
            }
            //B1C1-B2C2
            else {
                addedTriangle1.bcnext = addedTriangle2;
                addedTriangle2.bcnext = addedTriangle1;
            }
        }
        //B1-C2
        else if (B1.equals(C2)) {
            //B1A1-C2A2
            if (A1.equals(A2)) {
                addedTriangle1.abnext = addedTriangle2;
                addedTriangle2.canext = addedTriangle1;
            }
            //B1A1-C2B2
            if (A1.equals(B2)) {
                addedTriangle1.abnext = addedTriangle2;
                addedTriangle2.bcnext = addedTriangle1;
            }
            //B1C1-C2A2
            if (C1.equals(A2)) {
                addedTriangle1.bcnext = addedTriangle2;
                addedTriangle2.canext = addedTriangle1;
            }
            //B1C1-C2B2
            else {
                addedTriangle1.bcnext = addedTriangle2;
                addedTriangle2.bcnext = addedTriangle1;
            }
        }
        //C1-A2
        else if (C1.equals(A2)) {
            //C1A1-A2B2
            if (A1.equals(B2)) {
                addedTriangle1.canext = addedTriangle2;
                addedTriangle2.abnext = addedTriangle1;
            }
            //C1A1-A2C2
            else if (A1.equals(C2)) {
                addedTriangle1.canext = addedTriangle2;
                addedTriangle2.canext = addedTriangle1;
            }
            //C1B1-A2B2
            else if (B1.equals(B2)) {
                addedTriangle1.bcnext = addedTriangle2;
                addedTriangle2.abnext = addedTriangle1;
            }
            //C1B1-A2C2
            else {
                addedTriangle1.bcnext = addedTriangle2;
                addedTriangle2.canext = addedTriangle1;
            }
        }
        //C1-B2
        else if (C1.equals(B2)) {
            //C1A1-B2A2
            if (A1.equals(A2)) {
                addedTriangle1.canext = addedTriangle2;
                addedTriangle2.abnext = addedTriangle1;
            }
            //C1A1-B2C2
            else if (A1.equals(C2)) {
                addedTriangle1.canext = addedTriangle2;
                addedTriangle2.bcnext = addedTriangle1;
            }
            //C1B1-B2A2
            else if (B1.equals(A2)) {
                addedTriangle1.bcnext = addedTriangle2;
                addedTriangle2.abnext = addedTriangle1;
            }
            //C1B1-B2C2
            else {
                addedTriangle1.bcnext = addedTriangle2;
                addedTriangle2.bcnext = addedTriangle1;
            }
        }
        //C1-C2
        else if (C1.equals(C2)) {
            //C1A1-C2A2
            if (A1.equals(A2)) {
                addedTriangle1.canext = addedTriangle2;
                addedTriangle2.canext = addedTriangle1;
            }
            //C1A1-C2B2
            if (A1.equals(B2)) {
                addedTriangle1.canext = addedTriangle2;
                addedTriangle2.bcnext = addedTriangle1;
            }
            //C1B1-C2A2
            if (B1.equals(A2)) {
                addedTriangle1.bcnext = addedTriangle2;
                addedTriangle2.canext = addedTriangle1;
            }
            //C1B1-C2B2
            else {
                addedTriangle1.bcnext = addedTriangle2;
                addedTriangle2.bcnext = addedTriangle1;
            }
        }
    },

    //finds the a point on the triangle that if connect it to "point" (creating a segment)
    //the other two points of the triangle will be to the left and to the right of the segment
    //by Doron Ganel & Eyal Roth(2009)
    findDiagonal: function(triangle, point) {
        var p1 = triangle.p1();
        var p2 = triangle.p2();
        var p3 = triangle.p3();

        if ((p1.pointLineTest(point, p3) == Point3D.LEFT) &&
            (p2.pointLineTest(point, p3) == Point3D.RIGHT))
            return p3;
        if ((p3.pointLineTest(point, p2) == Point3D.LEFT) &&
            (p1.pointLineTest(point, p2) == Point3D.RIGHT))
            return p2;
        if ((p2.pointLineTest(point, p1) == Point3D.LEFT) &&
            (p3.pointLineTest(point, p1) == Point3D.RIGHT))
            return p1;
        return null;
    },

    /**
     * Calculates a Voronoi cell for a given neighborhood
     * in this triangulation. A neighborhood is defined by a triangle
     * and one of its corner points.
     *  
     * By Udi Schneider
     * 
     * @param triangle a triangle in the neighborhood  
     * @param p corner point whose surrounding neighbors will be checked
     * @return set of Points representing the cell polygon
     */
    calcVoronoiCell: function(triangle, p) {
        // handle any full triangle      
        if (!triangle.isHalfplane()) {

            // get all neighbors of given corner point
            var neighbors = this.findTriangleNeighborhood(triangle, p);
            var vertices = [];
            // for each neighbor, including the given triangle, add
            // center of circumscribed circle to cell polygon
            for (var i = 0; i < neighbors.length; i++) {
                var tmp = neighbors[i];
                vertices.push(tmp.circumcircle().center);
            }
            return vertices;
        }
        // handle half plane
        // in this case, the cell is a single line
        // which is the perpendicular bisector of the half plane line
        else {
            // local friendly alias         
            var halfplane = triangle;
            // third point of triangle adjacent to this half plane
            // (the point not shared with the half plane)
            var third = null;
            // triangle adjacent to the half plane
            var neighbor = null;

            // find the neighbor triangle
            if (!halfplane.next_12().isHalfplane()) {
                neighbor = halfplane.next_12();
            } else if (!halfplane.next_23().isHalfplane()) {
                neighbor = halfplane.next_23();
            } else if (!halfplane.next_23().isHalfplane()) {
                neighbor = halfplane.next_31();
            }

            // find third point of neighbor triangle
            // (the one which is not shared with current half plane)
            // this is used in determining half plane orientation
            if (!neighbor.p1().equals(halfplane.p1()) && !neighbor.p1().equals(halfplane.p2()))
                third = neighbor.p1();
            if (!neighbor.p2().equals(halfplane.p1()) && !neighbor.p2().equals(halfplane.p2()))
                third = neighbor.p2();
            if (!neighbor.p3().equals(halfplane.p1()) && !neighbor.p3().equals(halfplane.p2()))
                third = neighbor.p3();

            // delta (slope) of half plane edge
            var halfplane_delta = (halfplane.p1().y - halfplane.p2().y) /
                (halfplane.p1().x - halfplane.p2().x);

            // delta of line perpendicular to current half plane edge
            var perp_delta = (1.0 / halfplane_delta) * (-1.0);

            // determine orientation: find if the third point of the triangle
            // lies above or below the half plane
            // works by finding the matching y value on the half plane line equation
            // for the same x value as the third point
            var y_orient = halfplane_delta * (third.x - halfplane.p1().x) + halfplane.p1().y;
            var above = true;
            if (y_orient > third.y)
                above = false;

            // based on orientation, determine cell line direction
            // (towards right or left side of window)
            var sign = 1.0;
            if ((perp_delta < 0 && !above) || (perp_delta > 0 && above))
                sign = -1.0;

            // the cell line is a line originating from the circumcircle to infinity
            // x = 500.0 is used as a large enough value
            var circumcircle = neighbor.circumcircle().center;
            var x_cell_line = (circumcircle.x + (500.0 * sign));
            var y_cell_line = perp_delta * (x_cell_line - circumcircle.x) + circumcircle.y;

            var result = [];
            result.push(circumcircle);
            result.push(new Point3D(x_cell_line, y_cell_line));

            return result;
        }
    },

    /**
     * returns an iterator object involved in the last update.
     * @return iterator to all triangles involved in the last update of the
     *         triangulation NOTE: works ONLY if the are triangles (it there is
     *         only a half plane - returns an empty iterator
     */
    getLastUpdatedTriangles: function() {
        var tmp = [];
        if (this.getTrianglesLength() > 1) {
            var t = this._currT;
            this.allTriangles(t, tmp, this._modCount);
        }
        return tmp;
    },

    allTriangles: function(curr, front, mc) {
        if (curr != null && curr.mc == mc && !(front.indexOf(curr) >= 0)) {
            front.push(curr);
            this.allTriangles(curr.abnext, front, mc);
            this.allTriangles(curr.bcnext, front, mc);
            this.allTriangles(curr.canext, front, mc);
        }
    },

    insertPointSimple: function(p) {
        this._nPoints++;
        if (!this._allCollinear) {
            var t = this._find(this._startTriangle, p);
            if (t.isHalfplane())
                this._startTriangle = this.extendOutside(t, p);
            else
                this._startTriangle = this.extendInside(t, p);
            return this._startTriangle;
        }

        if (this._nPoints == 1) {
            this._firstP = p;
            return null;
        }

        if (this._nPoints == 2) {
            this.startTriangulation(this._firstP, p);
            return null;
        }

        switch (p.pointLineTest(this._firstP, this._lastP)) {
            case Point3D.LEFT:
                this._startTriangle = this.extendOutside(this._firstT.abnext, p);
                this._allCollinear = false;
                break;
            case Point3D.RIGHT:
                this._startTriangle = this.extendOutside(this._firstT, p);
                this._allCollinear = false;
                break;
            case Point3D.ONSEGMENT:
                this.insertCollinear(p, Point3D.ONSEGMENT);
                break;
            case Point3D.INFRONTOFA:
                this.insertCollinear(p, Point3D.INFRONTOFA);
                break;
            case Point3D.BEHINDB:
                this.insertCollinear(p, Point3D.BEHINDB);
                break;
        }
        return null;
    },

    insertCollinear: function(p, res) {
        var t;
        var tp;
        var u;

        switch (res) {
            case Point3D.INFRONTOFA:
                t = new TriangleDT(this._firstP, p);
                tp = new TriangleDT(p, this._firstP);
                t.abnext = tp;
                tp.abnext = t;
                t.bcnext = tp;
                tp.canext = t;
                t.canext = this._firstT;
                this._firstT.bcnext = t;
                tp.bcnext = this._firstT.abnext;
                this._firstT.abnext.canext = tp;
                this._firstT = t;
                this._firstP = p;
                break;
            case Point3D.BEHINDB:
                t = new TriangleDT(p, this._lastP);
                tp = new TriangleDT(this._lastP, p);
                t.abnext = tp;
                tp.abnext = t;
                t.bcnext = this._lastT;
                this._lastT.canext = t;
                t.canext = tp;
                tp.bcnext = t;
                tp.canext = this._lastT.abnext;
                this._lastT.abnext.bcnext = tp;
                this._lastT = t;
                this._lastP = p;
                break;
            case Point3D.ONSEGMENT:
                // eslint-disable-next-line no-undef
                u = _firstT;
                while (p.isGreater(u.a))
                    u = u.canext;
                t = new TriangleDT(p, u.b);
                tp = new TriangleDT(u.b, p);
                u.b = p;
                u.abnext.a = p;
                t.abnext = tp;
                tp.abnext = t;
                t.bcnext = u.bcnext;
                u.bcnext.canext = t;
                t.canext = u;
                u.bcnext = t;
                tp.canext = u.abnext.canext;
                u.abnext.canext.bcnext = tp;
                tp.bcnext = u.abnext;
                u.abnext.canext = tp;
                if (this._firstT == u) {
                    this._firstT = t;
                }
                break;
        }
    },

    startTriangulation: function(p1, p2) {
        var ps;
        var pb;

        if (p1.isLess(p2)) {
            ps = p1;
            pb = p2;
        } else {
            ps = p2;
            pb = p1;
        }
        this._firstT = new TriangleDT(pb, ps);
        this._lastT = this._firstT;
        var t = new TriangleDT(ps, pb);
        this._firstT.abnext = t;
        t.abnext = this._firstT;
        this._firstT.bcnext = t;
        t.canext = this._firstT;
        this._firstT.canext = t;
        t.bcnext = this._firstT;
        this._firstP = this._firstT.b;
        this._lastP = this._lastT.a;
        this.startTriangleHull = this._firstT;
    },

    extendInside: function(t, p) {

        var h1;
        var h2;

        h1 = this.treatDegeneracyInside(t, p);

        if (h1 != null)
            return h1;

        h1 = new TriangleDT(t.c, t.a, p);
        h2 = new TriangleDT(t.b, t.c, p);
        t.c = p;
        t.circumcircle();
        h1.abnext = t.canext;
        h1.bcnext = t;
        h1.canext = h2;
        h2.abnext = t.bcnext;
        h2.bcnext = h1;
        h2.canext = t;
        h1.abnext.switchneighbors(t, h1);
        h2.abnext.switchneighbors(t, h2);
        t.bcnext = h2;
        t.canext = h1;
        return t;
    },

    treatDegeneracyInside: function(t, p) {
        if (t.abnext.isHalfplane() &&
            p.pointLineTest(t.b, t.a) == Point3D.ONSEGMENT)
            return this.extendOutside(t.abnext, p);
        if (t.bcnext.isHalfplane() &&
            p.pointLineTest(t.c, t.b) == Point3D.ONSEGMENT)
            return this.extendOutside(t.bcnext, p);
        if (t.canext.isHalfplane() &&
            p.pointLineTest(t.a, t.c) == Point3D.ONSEGMENT)
            return this.extendOutside(t.canext, p);
        return null;
    },

    extendOutside: function(t, p) {
        if (p.pointLineTest(t.a, t.b) == Point3D.ONSEGMENT) {
            var dg = new TriangleDT(t.a, t.b, p);
            var hp = new TriangleDT(p, t.b);
            t.b = p;
            dg.abnext = t.abnext;
            dg.abnext.switchneighbors(t, dg);
            dg.bcnext = hp;
            hp.abnext = dg;
            dg.canext = t;
            t.abnext = dg;
            hp.bcnext = t.bcnext;
            hp.bcnext.canext = hp;
            hp.canext = t;
            t.bcnext = hp;
            return dg;
        }
        var ccT = this.extendcounterclock(t, p);
        var cT = this.extendclock(t, p);
        ccT.bcnext = cT;
        cT.canext = ccT;
        this.startTriangleHull = cT;
        return cT.abnext;
    },

    extendcounterclock: function(t, p) {
        t.setIsHalfplane(false);
        t.c = p;
        t.circumcircle();

        var tca = t.canext;

        if (p.pointLineTest(tca.a, tca.b) >= Point3D.RIGHT) {
            var nT = new TriangleDT(t.a, p);
            nT.abnext = t;
            t.canext = nT;
            nT.canext = tca;
            tca.bcnext = nT;
            return nT;
        }
        return this.extendcounterclock(tca, p);
    },

    extendclock: function(t, p) {
        t.setIsHalfplane(false);
        t.c = p;
        t.circumcircle();

        var tbc = t.bcnext;

        if (p.pointLineTest(tbc.a, tbc.b) >= Point3D.RIGHT) {
            var nT = new TriangleDT(p, t.b);
            nT.abnext = t;
            t.bcnext = nT;
            nT.bcnext = tbc;
            tbc.canext = nT;
            return nT;
        }
        return this.extendclock(tbc, p);
    },

    flip: function(t, mc) {

        var u = t.abnext;
        var v;
        t.mc = mc;
        if (u.isHalfplane() || !u.circumcircle_contains(t.c))
            return;

        if (t.a == u.a) {
            v = new TriangleDT(u.b, t.b, t.c);
            v.abnext = u.bcnext;
            t.abnext = u.abnext;
        } else if (t.a == u.b) {
            v = new TriangleDT(u.c, t.b, t.c);
            v.abnext = u.canext;
            t.abnext = u.bcnext;
        } else if (t.a == u.c) {
            v = new TriangleDT(u.a, t.b, t.c);
            v.abnext = u.abnext;
            t.abnext = u.canext;
        } else {
            throw "Error in flip.";
        }

        v.mc = mc;
        v.bcnext = t.bcnext;
        v.abnext.switchneighbors(u, v);
        v.bcnext.switchneighbors(t, v);
        t.bcnext = v;
        v.canext = t;
        t.b = v.a;
        t.abnext.switchneighbors(u, t);
        t.circumcircle();

        this._currT = v;
        this.flip(t, mc);
        this.flip(v, mc);
    },

    /**
     * finds the triangle the query point falls in, note if out-side of this
     * triangulation a half plane triangle will be returned (see contains), the
     * search has expected time of O(n^0.5), and it starts form a fixed triangle
     * (this.startTriangle),
     *
     * @param p
     *            query point
     * @return the triangle that point p is in.
     */
    find: function(p) {
        // If triangulation has a spatial index try to use it as the starting triangle
        var searchTriangle = this._startTriangle;
        if (this._gridIndex != null) {
            var indexTriangle = this._gridIndex.findCellTriangleOf(p);
            if (indexTriangle != null)
                searchTriangle = indexTriangle;
        }

        // Search for the point's triangle starting from searchTriangle
        return this._find(searchTriangle, p);
    },

    /**
     * finds the triangle the query point falls in, note if out-side of this
     * triangulation a half plane triangle will be returned (see contains). the
     * search starts from the the start triangle
     *
     * @param p
     *            query point
     * @param start
     *            the triangle the search starts at.
     * @return the triangle that point p is in..
     */
    findWithStart: function(p, start) {
        if (start == null)
            start = this._startTriangle;
        var T = this._find(start, p);
        return T;
    },


    _find: function(curr, p) {
        if (p == null)
            return null;
        var next_t;
        if (curr.isHalfplane()) {
            next_t = this.findnext2(p, curr);
            if (next_t == null || next_t.isHalfplane())
                return curr;
            curr = next_t;
        }
        // eslint-disable-next-line no-constant-condition
        while (true) {
            next_t = this.findnext1(p, curr);
            if (next_t == null)
                return curr;
            if (next_t.isHalfplane())
                return next_t;
            curr = next_t;
        }
        // eslint-disable-next-line no-unreachable
        return null;
    },

    /*
     * assumes v is NOT an halfplane!
     * returns the next triangle for find.
     */
    findnext1: function(p, v) {
        if (p.pointLineTest(v.a, v.b) == Point3D.RIGHT && !v.abnext.isHalfplane())
            return v.abnext;
        if (p.pointLineTest(v.b, v.c) == Point3D.RIGHT && !v.bcnext.isHalfplane())
            return v.bcnext;
        if (p.pointLineTest(v.c, v.a) == Point3D.RIGHT && !v.canext.isHalfplane())
            return v.canext;
        if (p.pointLineTest(v.a, v.b) == Point3D.RIGHT)
            return v.abnext;
        if (p.pointLineTest(v.b, v.c) == Point3D.RIGHT)
            return v.bcnext;
        if (p.pointLineTest(v.c, v.a) == Point3D.RIGHT)
            return v.canext;
        return null;
    },

    /** assumes v is an halfplane! - returns another (none halfplane) triangle */
    findnext2: function(p, v) {
        if (v.abnext != null && !v.abnext.isHalfplane())
            return v.abnext;
        if (v.bcnext != null && !v.bcnext.isHalfplane())
            return v.bcnext;
        if (v.canext != null && !v.canext.isHalfplane())
            return v.canext;
        return null;
    },

    /* 
     * Receives a point and returns all the points of the triangles that
     * shares point as a corner (Connected vertices to this point).
     * 
     * By Doron Ganel & Eyal Roth
     */
    findConnectedVertices: function(point) {
        return this._findConnectedVertices(point, false);
    },

    /* 
     * Receives a point and returns all the points of the triangles that
     * shares point as a corner (Connected vertices to this point).
     * 
     * Set saveTriangles to true if you wish to save the triangles that were found.
     * 
     * By Doron Ganel & Eyal Roth
     */
    _findConnectedVertices: function(point, saveTriangles) {
        var pointsSet = [];
        var pointsVec = [];
        var triangles = null;

        // Getting one of the neigh
        var triangle = this.find(point);

        // Validating find result.
        if (!triangle.isCorner(point)) {
            console.info("findConnectedVertices: Could not find connected vertices since the first found triangle doesn't share the given point.");
            return null;
        }

        triangles = this.findTriangleNeighborhood(triangle, point);
        if (triangles == null) {
            console.info("Error: can't delete a point on the perimeter");
            return null;
        }
        if (saveTriangles) {
            this._deletedTriangles = triangles;
        }

        for (var i = 0; i < triangles.length; i++) {
            var tmpTriangle = triangles[i];
            var point1 = tmpTriangle.p1();
            var point2 = tmpTriangle.p2();
            var point3 = tmpTriangle.p3();

            if (point1.equals(point) && !(pointsSet.indexOf(point2) >= 0)) {
                pointsSet.push(point2);
                pointsVec.push(point2);
            }

            if (point2.equals(point) && !(pointsSet.indexOf(point3) >= 0)) {
                pointsSet.push(point3);
                pointsVec.push(point3);
            }

            if (point3.equals(point) && !(pointsSet.indexOf(point1) >= 0)) {
                pointsSet.push(point1);
                pointsVec.push(point1);
            }
        }

        return pointsVec;
    },

    onPerimeter: function(triangles) {
        for (var i = 0; i < triangles.length; i++) {
            var t = triangles[i];
            if (t.isHalfplane())
                return true;
        }
        return false;
    },

    // Walks on a consistent side of triangles until a cycle is achieved.
    //By Doron Ganel & Eyal Roth
    // changed to public by Udi
    findTriangleNeighborhood: function(firstTriangle, point) {
        var triangles = [];
        triangles.push(firstTriangle);

        var prevTriangle = null;
        var currentTriangle = firstTriangle;
        var nextTriangle = currentTriangle.nextNeighbor(point, prevTriangle);

        while (nextTriangle != firstTriangle) {
            //the point is on the perimeter
            if (nextTriangle.isHalfplane()) {
                return null;
            }
            triangles.push(nextTriangle);
            prevTriangle = currentTriangle;
            currentTriangle = nextTriangle;
            nextTriangle = currentTriangle.nextNeighbor(point, prevTriangle);
        }

        return triangles;
    },

    /*
     * find triangle to be added to the triangulation
     * 
     * By: Doron Ganel & Eyal Roth
     * 
     */
    findTriangle: function(pointsVec, p) {
        var arrayPoints = ArrayUtils.copy(pointsVec);

        var size = arrayPoints.length;
        if (size < 3) {
            return null;
        }
        // if we left with 3 points we return the triangle
        else if (size == 3) {
            return new TriangleDT(arrayPoints[0], arrayPoints[1], arrayPoints[2]);
        } else {
            for (var i = 0; i <= size - 1; i++) {
                var p1 = arrayPoints[i];
                var j = i + 1;
                var k = i + 2;
                if (j >= size) {
                    j = 0;
                    k = 1;
                }
                //check IndexOutOfBound
                else if (k >= size) {
                    k = 0;
                }

                var p2 = arrayPoints[j];
                var p3 = arrayPoints[k];
                //check if the triangle is not re-entrant and not encloses p
                var t = new TriangleDT(p1, p2, p3);
                if ((this.calcDet(p1, p2, p3) >= 0) && !t.contains(p)) {
                    if (!t.fallInsideCircumcircle(arrayPoints))
                        return t;
                }
                //if there are only 4 points use contains that refers to point
                //on boundary as outside
                if (size == 4 && (this.calcDet(p1, p2, p3) >= 0) && !t.contains_BoundaryIsOutside(p)) {
                    if (!t.fallInsideCircumcircle(arrayPoints))
                        return t;
                }
            }
        }
        return null;
    },

    // TODO: Move this to triangle.
    //checks if the triangle is not re-entrant
    calcDet: function(A, B, P) {
        return (A.x * (B.y - P.y)) - (A.y * (B.x - P.x)) + (B.x * P.y - B.y * P.x);
    },



    /**
     *
     * @param p
     *            query point
     * @return true iff p is within this triangulation (in its 2D convex hull).
     */

    containsPoint: function(p) {
        var tt = this.find(p);
        return !tt.isHalfplane();
    },

    /**
     *
     * @param x
     *            - X cordination of the query point
     * @param y
     *            - Y cordination of the query point
     * @return true iff (x,y) falls inside this triangulation (in its 2D convex
     *         hull).
     */
    contains: function(x, y) {
        return this.containsPoint(new Point3D(x, y));
    },

    /**
     *
     * @param q
     *            Query point
     * @return the q point with updated Z value (z value is as given the
     *         triangulation).
     */
    zPoint: function(q) {
        var t = this.find(q);
        return t.computeZPoint(q);
    },

    /**
     *
     * @param x
     *            - X cordination of the query point
     * @param y
     *            - Y cordination of the query point
     * @return the q point with updated Z value (z value is as given the
     *         triangulation).
     */
    z: function(x, y) {
        var q = new Point3D(x, y);
        var t = this.find(q);
        return t.z_value(q);
    },

    updateBoundingBox: function(p) {
        var x = p.x;
        var y = p.y;
        var z = p.z;
        if (this._bb_min == null) {
            this._bb_min = p.clone();
            this._bb_max = p.clone();
        } else {
            if (x < this._bb_min.x)
                this._bb_min.x = x;
            else if (x > this._bb_max.x)
                this._bb_max.x = x;
            if (y < this._bb_min.y)
                this._bb_min.y = y;
            else if (y > this._bb_max.y)
                this._bb_max.y = y;
            if (z < this._bb_min.z)
                this._bb_min.z = z;
            else if (z > this._bb_max.z)
                this._bb_max.z = z;
        }
    },

    /**
     * @return  The bounding rectange between the minimum and maximum coordinates
     */
    getBoundingBox: function() {
        return BoundingBoxDT.createFromLowerLeftAndUpperRight(this._bb_min, this._bb_max);
    },

    /**
     * return the min point of the bounding box of this triangulation
     * {{x0,y0,z0}}
     */
    minBoundingBox: function() {
        return this._bb_min;
    },

    /**
     * return the max point of the bounding box of this triangulation
     * {{x1,y1,z1}}
     */
    maxBoundingBox: function() {
        return this._bb_max;
    },

    /**
     * computes the current set (vector) of all triangles and
     * return an iterator to them.
     *
     * @return an iterator to the current set of all triangles.
     */
    trianglesIterator: function() {
        if (this.getLength() <= 2)
            this._triangles = [];
        this.initTriangles();
        return this._triangles;
    },

    /**
     * returns an iterator to the set of all the points on the XY-convex hull
     * @return iterator to the set of all the points on the XY-convex hull.
     */
    CH_vertices_Iterator: function() {
        var ans = [];
        var curr = this.startTriangleHull;
        var cont = true;
        var x0 = this._bb_min.x;
        var x1 = this._bb_max.x;
        var y0 = this._bb_min.y;
        var y1 = this._bb_max.y;
        var sx;
        var sy;
        while (cont) {
            sx = curr.p1().x == x0 || curr.p1().x == x1;
            sy = curr.p1().y == y0 || curr.p1().y == y1;
            if ((sx && sy) || (!sx && !sy)) {
                ans.add(curr.p1());
            }
            if (curr.bcnext != null && curr.bcnext.isHalfplane())
                curr = curr.bcnext;
            if (curr == this.startTriangleHull)
                cont = false;
        }
        return ans;
    },

    /**
     * returns an iterator to the set of points compusing this triangulation.
     * @return iterator to the set of points compusing this triangulation.
     */
    verticesIterator: function() {
        return this._vertices;
    },

    initTriangles: function() {
        if (this._modCount == this._modCount2)
            return;
        if (this.getLength() > 2) {
            this._modCount2 = this._modCount;
            var front = [];
            this._triangles = [];
            front.push(this._startTriangle);
            while (front.length > 0) {
                var t = front[0];
                ArrayUtils.deleteAt(front, 0)
                if (t.mark == false) {
                    t.mark = true;
                    this._triangles.push(t);
                    if (t.abnext != null && !t.abnext.mark) {
                        front.push(t.abnext);
                    }
                    if (t.bcnext != null && !t.bcnext.mark) {
                        front.push(t.bcnext);
                    }
                    if (t.canext != null && !t.canext.mark) {
                        front.push(t.canext);
                    }
                }
            }
            // _triNum = _triangles.size();
            for (var i = 0; i < this._triangles.length; i++) {
                this._triangles[i].mark = false;
            }
        }
    },

    /**
     * Index the triangulation using a grid index
     *  @param   xCellCount        number of grid cells in a row
     *  @param   yCellCount        number of grid cells in a column
     */
    IndexData: function(xCellCount, yCellCount) {
        this._gridIndex = new GridIndex(this, xCellCount, yCellCount);
    },

    /**
     * Remove any existing spatial indexing
     */
    RemoveIndex: function() {
        this._gridIndex = null;
    }


};

GridIndex.prototype = {

    _init: function(delaunay, xCellCount, yCellCount, region) {
        this._indexDelaunay = delaunay;
        this._indexRegion = region;
        this._xSize = region.getWidth() / yCellCount;
        this._ySize = region.getHeight() / xCellCount;

        this._grid = [];
        for (var x = 0; x < xCellCount; x++) {
            this._grid[x] = [];
        }

        var colStartTriangle = this._indexDelaunay.find(this.middleOfCell(0, 0));
        this.updateCellValues(0, 0, xCellCount - 1, yCellCount - 1, colStartTriangle);
    },

    /**
     * Finds a triangle near the given point
     * @param point     a query point
     * @return              a triangle at the same cell of the point
     */
    findCellTriangleOf: function(point) {

        var x_index = (((point.x - this._indexRegion.minX) / this._xSize)) | 0;
        var y_index = (((point.y - this._indexRegion.minY) / this._ySize)) | 0;
        return this._grid[x_index][y_index];
    },

    /**
     * Updates the grid index to reflect changes to the triangulation. Note that added
     * triangles outside the indexed region will force to recompute the whole index
     * with the enlarged region.
     */
    /**
     * Updates the grid index to reflect changes to the triangulation. Note that added
     * triangles outside the indexed region will force to recompute the whole index
     * with the enlarged region.
     *
     * @param updatedTriangles      changed triangles of the triangulation. This may be added triangles,
     *                                             removed triangles or both. All that matter is that they cover the
     *                                             changed area.
     */
    updateIndex: function(updatedTriangles) {
        // Gather the bounding box of the updated area
        var updatedRegion = new BoundingBoxDT();

        for (var i = 0; i < updatedTriangles.length; i++) {
            var tr = updatedTriangles[i];
            updatedRegion = updatedRegion.unionWith(tr.getBoundingBox());
        }

        if (updatedRegion.isNull()) // No update...
            return;

        // Bad news - the updated region lies outside the indexed region.
        // The whole index must be recalculated
        if (!this._indexRegion.contains(updatedRegion)) {
            this._init(this._indexDelaunay,
                (this._indexRegion.getWidth() / this._xSize) | 0,
                (this._indexRegion.getHeight() / this._ySize) | 0,
                this._indexRegion.unionWith(updatedRegion));
        } else {
            // Find the cell region to be updated
            var minInvalidCell = this.getCellOf(updatedRegion.getMinPoint());
            var maxInvalidCell = this.getCellOf(updatedRegion.getMaxPoint());

            // And update it with fresh triangles
            var adjacentValidTriangle = this.findValidTriangle(minInvalidCell);
            this.updateCellValues(minInvalidCell.x, minInvalidCell.y, maxInvalidCell.x, maxInvalidCell.y, adjacentValidTriangle);
        }
    },

    updateCellValues: function(startXCell, startYCell, lastXCell, lastYCell, startTriangle) {
        // Go over each grid cell and locate a triangle in it to be the cell's
        // starting search triangle. Since we only pass between adjacent cells
        // we can search from the last triangle found and not from the start.

        // Add triangles for each column cells
        for (var i = startXCell; i <= lastXCell; i++) {
            // Find a triangle at the begining of the current column
            startTriangle = this._indexDelaunay.findWithStart(this.middleOfCell(i, startYCell), startTriangle);
            this._grid[i][startYCell] = startTriangle;
            var prevRowTriangle = startTriangle;

            // Add triangles for the next row cells
            for (var j = startYCell + 1; j <= lastYCell; j++) {
                this._grid[i][j] = this._indexDelaunay.findWithStart(this.middleOfCell(i, j), prevRowTriangle);
                prevRowTriangle = this._grid[i][j];
            }
        }
    },

    /**
     *  Finds a valid (existing) trinagle adjacent to a given invalid cell
     * @param minInvalidCell    minimum bounding box invalid cell
     * @return                           a valid triangle adjacent to the invalid cell
     */
    findValidTriangle: function(minInvalidCell) {
        // If the invalid cell is the minimal one in the grid we are forced to search the
        // triangulation for a trinagle at that location
        if (minInvalidCell.x == 0 && minInvalidCell.y == 0)
            return this._indexDelaunay.findWithStart(this.middleOfCell(minInvalidCell.x, minInvalidCell.y), null);
        else
        // Otherwise we can take an adjacent cell triangle that is still valid
            return this._grid[Math.min(0, minInvalidCell.x)][Math.min(0, minInvalidCell.y)];
    },

    /**
     * Locates the grid cell point covering the given coordinate
     * @param coordinate        world coordinate to locate
     * @return                         cell covering the coordinate
     */
    getCellOf: function(coordinate) {
        var xCell = ((coordinate.x - this._indexRegion.minX) / this._xSize) | 0;
        var yCell = ((coordinate.y - this._indexRegion.minY) / this._ySize) | 0;
        return new Point(xCell, yCell);
    },

    /**
     * Create a point at the center of a cell
     * @param x_index   horizontal cell index
     * @param y_index   vertical cell index
     * @return                Point at the center of the cell at (x_index, y_index)
     */
    middleOfCell: function(x_index, y_index) {
        var middleXCell = this._indexRegion.minX + x_index * this._xSize + this._xSize / 2;
        var middleYCell = this._indexRegion.minY + y_index * this._ySize + this._ySize / 2;
        return new Point3D(middleXCell, middleYCell);
    }
}

export default DelaunayTriangulation;